import MaterialIconsReact from "material-icons-react";
import React, { useState } from "react";
import styles from "./SimpleSearchInput.module.css";

function SimpleSearchInput(props) {
  const [inputVal, setInputVal] = useState(props.value || "");

  return (
    <span className={styles.inputContainer}>
      {props.icon !== false && (
        <div className={styles.iconContainer} style={props.iconStyle}>
          <MaterialIconsReact icon="search" size={20}></MaterialIconsReact>
        </div>
      )}
      <div style={{ position: "relative" }}>
        <input
          type="text"
          autoComplete="off"
          placeholder={props.placeholder}
          className={styles.input + " ft-14"}
          onChange={(e) => setInputVal(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              props.onEnter(inputVal);
            }
          }}
          style={{
            ...props.style,
            borderRadius: props.icon === false ? "4px" : "0px",
          }}
          data-testid="searchInput"
          autoFocus={props.autoFocus}
          value={inputVal}
        />
      </div>
      {props.showClearIcon && inputVal ? (
        <div
          className={styles.iconContainer}
          style={props.iconStyle}
          onClick={() => {
            setInputVal("");
            props.onClear();
          }}
        >
          <MaterialIconsReact icon="close" size={20}></MaterialIconsReact>
        </div>
      ) : null}
    </span>
  );
}

export default SimpleSearchInput;
